
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';

export default function StickyConsultationButton() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(true);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const footer = document.querySelector('footer');
      if (footer) {
        const footerRect = footer.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        
        // Hide button when footer is visible
        if (footerRect.top < windowHeight) {
          setIsVisible(false);
        } else {
          setIsVisible(true);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check initial state
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    const isHomePage = location.pathname === '/';
    
    if (!isHomePage) {
      navigate('/#contact');
    } else {
      const contactSection = document.getElementById('contact');
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  if (!isVisible) return null;

  return (
    <button
      onClick={handleClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="fixed bottom-8 right-8 z-50 px-6 py-4 rounded-lg shadow-2xl transition-all duration-300 cursor-pointer whitespace-nowrap"
      style={{
        background: isHovered 
          ? 'linear-gradient(135deg, #9B2335 0%, #C8960C 100%)'
          : 'linear-gradient(135deg, #7A1A28 0%, #9B2335 100%)',
        border: '2px solid #C8960C',
        fontFamily: "'Noto Serif JP', serif",
        transform: isHovered ? 'scale(1.05) translateY(-2px)' : 'scale(1)',
        boxShadow: isHovered 
          ? '0 12px 40px rgba(155, 35, 53, 0.4)'
          : '0 8px 24px rgba(155, 35, 53, 0.3)',
      }}
    >
      <div className="flex items-center gap-3">
        <div 
          className="w-10 h-10 flex items-center justify-center rounded-full"
          style={{
            backgroundColor: 'rgba(245, 230, 200, 0.2)',
            border: '1px solid rgba(200, 150, 12, 0.4)',
          }}
        >
          <i className="ri-calendar-check-line text-xl" style={{ color: '#F5E6C8' }}></i>
        </div>
        <div className="text-left">
          <div className="text-sm font-semibold" style={{ color: '#F5E6C8' }}>
            {t('common:stickyButton.title', 'Free 30-Min')}
          </div>
          <div className="text-xs" style={{ color: '#EDD9A3' }}>
            {t('common:stickyButton.subtitle', 'Consultation')}
          </div>
        </div>
      </div>
      
      {/* Decorative corner accents */}
      <div 
        className="absolute top-1 left-1 w-3 h-3 border-t-2 border-l-2"
        style={{ borderColor: '#C8960C', opacity: 0.6 }}
      />
      <div 
        className="absolute bottom-1 right-1 w-3 h-3 border-b-2 border-r-2"
        style={{ borderColor: '#C8960C', opacity: 0.6 }}
      />
    </button>
  );
}
